
"use client";

import { useEffect, useState } from "react";
import Image from "next/image";
import styles from "./PromoPopup.module.scss";
import Link from "next/link";

export default function PromoPopup() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(true);
    }, 4000);

    return () => clearTimeout(timer);
  }, []);

  if (!show) return null;

  return (
    <div className={styles.popupOverlay}>
      <div className={styles.popupBox}>
        <div className={styles.imgWrapper}>
          <img
            src="/images/banners/promo-banner.jpeg"
            alt="Promotion banner"
          />

          <a href={'/tickets'} aria-label="Promotion Banner"></a>
        </div>

        <button
          className={styles.closeBtn}
          onClick={() => setShow(false)}
        >
          ✕ Close
        </button>
      </div>
    </div>
  );
}
